import { ImgHTMLAttributes, useState } from "react";
import { cn } from "@/lib/utils";

type Props = ImgHTMLAttributes<HTMLImageElement>;

const loadedSrcs = new Set<string>();

export default function Image(props: Props) {
  const { src, className, onLoad, ...rest } = props;
  const [loadedSrc, setLoadedSrc] = useState<string | null>(null);

  if (!src) {
    return null;
  }

  const isLoaded = loadedSrc === src || loadedSrcs.has(src);

  return (
    <img
      src={src}
      className={cn(
        "transition-opacity duration-300",
        className,
        !isLoaded && "opacity-0",
      )}
      onLoad={(event) => {
        loadedSrcs.add(src);
        setLoadedSrc(src);
        onLoad?.(event);
      }}
      {...rest}
    />
  );
}
